import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {take} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';
import {ExpertServiceModel} from '@features/expert-services/models/expert-services.model';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'app-expert-service-checkbox-update-dialog',
  templateUrl: './expert-service-checkbox-update-dialog.component.html',
  styleUrls: ['./expert-service-checkbox-update-dialog.component.scss']
})
export class ExpertServiceCheckboxUpdateDialogComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  selectedServiceIds: string[];
  expertServiceModels: ExpertServiceModel[];
  private selectedExpertServicesModels: ExpertServiceModel[];
  constructor(private platformQueryService: PlatformQueryService,
              private snackBarService: SnackBarService, ) {
  }

  ngOnDestroy(): void {
  }

  onOkClicked(): any {
    this.data.input.serviceIds = this.selectedServiceIds;
    return true;
  }
  onCancelClicked(): any {
    return true;
  }
  ngOnInit(): void {
    this.getExpertServiceModels();
    this.selectedServiceIds = this.data.input.selectedItems;
    this.data.isDisabledOkButton = true;
  }
  private getExpertServiceModels() {
    const query = new PlatformQuery();
    query.name = 'ExpertServiceModelsQuery';
    query.api = Api.MarketPlace;
    query.fieldValues['IsConsultant'] = true;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      if (response && response.fieldValues) {
        this.expertServiceModels = response.fieldValues['ExpertServiceModels'];
        if (this.expertServiceModels) {
          for (const item of this.selectedServiceIds) {
            const itemIndex = this.expertServiceModels.findIndex(element => element.id === item);
            if (itemIndex >= 0) {
              this.expertServiceModels[itemIndex].isChecked = true;
            }
          }
        }
      }
    });
  }
  onCheckBoxChange($event: MatCheckboxChange, item: any) {
    console.log($event, item);
    item.isChecked = $event.checked;
    if ($event.checked) {
      this.selectedServiceIds.push(item.id);
    } else {
      this.selectedServiceIds =  this.selectedServiceIds.filter(e => e !== item.id);
    }
    this.data.isDisabledOkButton = false;
  }

}
